import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-magnifier",
  "use": "icon-magnifier-usage",
  "viewBox": "0 0 15.73 15.74",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.73 15.74\" id=\"icon-magnifier\"><title>资源 115</title><g id=\"icon-magnifier_图层_2\" data-name=\"图层 2\"><g id=\"icon-magnifier_图层_1-2\" data-name=\"图层 1\"><path d=\"M14.38,12.27A7.87,7.87,0,1,0,2.3,13.43a7.86,7.86,0,0,0,10,1l.64.64A1.5,1.5,0,0,0,15,15a1.49,1.49,0,0,0,0-2.12Zm-10-1a4.86,4.86,0,1,1,3.44,1.43A4.86,4.86,0,0,1,4.42,11.31Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/magnifier.svg
// module id = G4MR
// module chunks = 72